export function getFileExtension(mimeType) {
    return mimeType.split('/')[1];
}
